import b from 'b_';
import React, { useRef } from 'react';

import { useMedia } from 'react-use';
import { QuizStudentParticles } from '../__particles/quiz-student__particles';
import SimpleLogo from '../../logo/_type/logo_type_simple';
import { MEDIA_QUERY_DESKTOP_L, MEDIA_QUERY_MOBILE_M } from '../../../utils/von-dyck-media-queries';

export enum QUIZ_STUDENT_THEME {
    START = 'start',
    DEFAULT = 'default',
    QUESTION = 'question',
    ANSWER_CORRECT = 'correct',
    ANSWER_INCORRECT = 'incorrect',
    FINISH = 'finish',
}

interface Props {
    children: React.ReactNode;
    name?: string;
    questionIndex?: number | null;
    theme?: QUIZ_STUDENT_THEME;
}

const QuizStudentWrapper = (props: Props) => {
    const { children, theme = QUIZ_STUDENT_THEME.DEFAULT } = props;
    const containerRef = useRef<HTMLDivElement>(null);
    const isSmallScreen = useMedia(MEDIA_QUERY_MOBILE_M);
    const isBigScreen = useMedia(MEDIA_QUERY_DESKTOP_L);

    return (
        <div className={b('quiz-student', { theme, small: isSmallScreen })} ref={containerRef}>
            {isBigScreen && <div className="quiz-student__background-cover-left" />}
            {isBigScreen && <div className="quiz-student__background-cover-right" />}
            <div className="quiz-student__header">
                <div className="quiz-student__header-item">
                    <SimpleLogo className="quiz-student__header-logo" isRouter={true} to="/kids" />
                </div>
            </div>
            {children}
            {theme === QUIZ_STUDENT_THEME.FINISH && <QuizStudentParticles contentRef={containerRef} />}
        </div>
    );
};

export default QuizStudentWrapper;
